import { useLang } from '@/i18n';
import Naver, { EfProductNaverItemProps, EfProductNaverProps } from '@elem/ui/ef-product-naver';
import { useEffect, useState } from 'react';
import { theme } from './config/page';
import css from './index.module.scss';
import { useProduct } from './ProductProvider';
import Bundle from './tabs/Bundle';
import Overview from './tabs/Overview';
import Spec from './tabs/Spec';
import Support from './tabs/Support';

const DPUX: React.FC = () => {
    const { state, dispatch } = useProduct();
    const { t } = useLang('d3u');
    const { productSupport, productSpecs, activeTab } = state;
    const [activetedTabs, setActivetedTabs] = useState<string[]>([activeTab]);

    const naverProps: EfProductNaverProps = {
        theme: theme as 'black' | 'white',
        title: t('naver_title'),
        tabs: [
            {
                key: 'Product',
                text: t('naver_tab_product'),
            },
            {
                key: 'Spec',
                text: t('naver_tab_spec'),
            },
            {
                key: 'Support',
                text: t('naver_tab_support'),
            },
        ],
        buyItem: {
            key: 'Bundles',
            text: t('naver_tab_buy'),
        },
        activeTab,
        buyNowGtm: {
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: t('C_tab1'),
            button_name: t('naver_tab_bundle'),
        },
        callbackBuy: () => {
            if (activeTab !== 'Bundles') {
                if (!activetedTabs.includes('Bundles')) {
                    setActivetedTabs([...activetedTabs, 'Bundles']);
                }
                dispatch({
                    type: 'changeProductTab',
                    payload: 'Bundles',
                });
            }
        },
        callbackTab: (tab: EfProductNaverItemProps) => {
            if (tab.key !== activeTab) {
                if (!activetedTabs.includes(tab.key)) {
                    setActivetedTabs([...activetedTabs, tab.key]);
                }
                dispatch({
                    type: 'changeProductTab',
                    payload: tab.key,
                });
                window.sessionStorage.removeItem('toTop-scrollTop');
                window.scrollTo({
                    top: 0,
                    behavior: 'instant',
                });
            }
        },
    };

    /** 检测浏览器是否支持使用 webp */
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const webP = new Image();
        webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        webP.onload = () => {
            dispatch({
                type: 'changeCanWebp',
                payload: 1,
            });
        };
        webP.onerror = () => {
            dispatch({
                type: 'changeCanWebp',
                payload: -1,
            });
        };
    }, [dispatch]);

    return (
        <>
            <div className={`delta-3-ultra-series GtmModuleData-section ${css.section}`} style={{ minHeight: '100vh' }} data-section-id="DELTA 3 Ultra Series">
                <Naver {...naverProps} />
                {activetedTabs.includes('Product') && (
                    <div className={`page-tab tab-overview ${activeTab === 'Product' ? 'active' : ''}`}>
                        <Overview />
                    </div>
                )}
                {activetedTabs.includes('Bundles') && (
                    <div className={`page-tab tab-Bundle ${activeTab === 'Bundles' ? 'active' : ''}`}>
                        <Bundle />
                    </div>
                )}
                {activetedTabs.includes('Spec') && (
                    <div className={`page-tab tab-Spec ${activeTab === 'Spec' ? 'active' : ''}`}>
                        <Spec productSpecs={productSpecs} theme={theme} />
                    </div>
                )}
                {activetedTabs.includes('Support') && (
                    <div className={`page-tab tab-support ${activeTab === 'Support' ? 'active' : ''}`}>
                        <Support supportData={productSupport} theme={theme} />
                    </div>
                )}
            </div>
        </>
    );
};

export default DPUX;
